import React from 'react';
import icon from './icon-close.svg';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './CloseIcon.css';

function CloseIcon({ url }) {
  return (
    <div className="close-icon">
      <Link to={url}>
        <img src={icon} alt="Close" />
      </Link>
    </div>
  );
}

CloseIcon.propTypes = {
  url: PropTypes.string
};

export default CloseIcon;



// WEBPACK FOOTER //
// ./src/components/CloseIcon/index.js